import { PayloadAction } from 'tabs/topQuestions/types/GenericTypes'
import { DateObject } from 'tabs/topQuestions/utils/DateUtils'

export type ColorRgb = [number, number, number]

export enum ClusteringStatus {
  NEW = 'NEW',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED'
}

export type ClusteringExecutionResponse = {
  colors: Record<string, number[]>
  clustersData: ClusteringExecutionData[]
}

export type ClusteringExecutionData = {
  clusterId: string
  executionClusters: ExecutionClusters[]
}

export type ClusteringStatusResponse = {
  clusteringExecutionId: string
  clusteringStatus: ClusteringStatus
}

export type ExecutionClusters = {
  //timestamp seconds
  endPeriod: number
  questionsCount: number
  faqCount: number
  daxCount: number
  unknownCount: number
  colorRgb: number[]
}

export type UpdateClusteringIsTraining = {
  clusteringId: string
  status: ClusteringStatus
}
export type BeginClusteringResponse = {
  clusteringId: string | undefined
  errorMessage: string | undefined
}

export const CLUSTERING_UPDATE_IS_TRAINING = 'CLUSTERING_UPDATE_IS_TRAINING'
export const LINE_CHART_FILTER_START_DATE_CHANGE = 'LINE_CHART_FILTER_START_DATE_CHANGE'
export const LINE_CHART_FILTER_END_DATE_CHANGE = 'LINE_CHART_FILTER_END_DATE_CHANGE'
export const START_CLUSTERING_REQ_PENDING = 'LINE_CHART_DATA_REQ_PENDING'
export const START_CLUSTERING_REQ_RESOLVED = 'LINE_CHART_DATA_REQ_RESOLVED'
export const START_CLUSTERING_REQ__REJECTED = 'LINE_CHART_DATA_REQ_REJECTED'

export type ClusteringUpdateIsTraining = PayloadAction<typeof CLUSTERING_UPDATE_IS_TRAINING, UpdateClusteringIsTraining>
export type LineChartFilterStartDateChange = PayloadAction<typeof LINE_CHART_FILTER_START_DATE_CHANGE, DateObject>
export type LineChartFilterEndDateChange = PayloadAction<typeof LINE_CHART_FILTER_END_DATE_CHANGE, DateObject>
export type StartClusteringReqPending = PayloadAction<typeof START_CLUSTERING_REQ_PENDING, undefined>
export type StartClusteringReqResolved = PayloadAction<typeof START_CLUSTERING_REQ_RESOLVED, BeginClusteringResponse>
export type StartClusteringReqRejected = PayloadAction<typeof START_CLUSTERING_REQ__REJECTED, undefined>

export type QuestionClusteringStatusActions = LineChartFilterStartDateChange
  | ClusteringUpdateIsTraining
  | LineChartFilterEndDateChange
  | StartClusteringReqPending
  | StartClusteringReqResolved
  | StartClusteringReqRejected
